import { IItem } from "@Front/Components/DesignSystem/Menu/MenuItem";
import { getOfficeItems as getNavigationOfficeItems } from "@Front/Components/DesignSystem/Header/Navigation/constants/officeItems";
import { getSuperAdminItems as getNavigationSuperAdminItems } from "@Front/Components/DesignSystem/Header/Navigation/constants/superAdminItems";

export function getOfficeItems(): IItem[] {
	return getNavigationOfficeItems();
}

export function getSuperAdminItems(): IItem[] {
	return getNavigationSuperAdminItems();
}
